import { ChangeDetectionStrategy, Component, inject, OnInit, Signal } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { BusinessModel, PaymentType } from '@us/web/shared/data-access';
import { first } from 'rxjs';
import { FormatCurrencyPipe, selectPaymentMethods } from '@us/web/shop/data-access';
import {
    Cart,
    CartActions,
    selectCart,
    selectCartPaymentType,
    selectCartTotal,
    selectLoading
} from '@us/web/cart/data-access';
import { Store } from '@ngrx/store';
import { IonicModule, NavController } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { PaymentTypeOptionsComponent } from '@us/web/orders/ui';
import { TuiButtonModule } from '@taiga-ui/core';
import { isFnBApp, RouteUtil } from '@us/web/shared/utils';
import { ENVIRONMENT } from '@us/app-config';
import { OrderItemsComponent } from '@us/web/orders/feature';

@Component({
    selector: 'us-cart-checkout',
    standalone: true,
    imports: [
        IonicModule,
        TranslocoModule,
        PaymentTypeOptionsComponent,
        AsyncPipe,
        TuiButtonModule,
        FormatCurrencyPipe,
        NgClass,
        OrderItemsComponent
    ],
    templateUrl: './cart-checkout.page.html',
    styleUrls: ['./cart-checkout.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartCheckoutPage implements OnInit {
    private readonly store = inject(Store);
    private readonly navController = inject(NavController);
    readonly cartRouteUrl = RouteUtil.getCartRouteUrl();

    readonly paymentMethods: Signal<PaymentType[]> = this.store.selectSignal(selectPaymentMethods);
    readonly total = this.store.selectSignal(selectCartTotal);
    readonly cart: Signal<Cart> = this.store.selectSignal(selectCart);
    readonly loading: Signal<boolean> = this.store.selectSignal(selectLoading);
    private readonly env = inject(ENVIRONMENT);
    readonly isFnb = isFnBApp(this.env);

    paymentType: PaymentType | null = null;

    ngOnInit() {
        this.store
            .select(selectCartPaymentType)
            .pipe(first())
            .subscribe(value => {
                if (value !== null) {
                    this.paymentType = value;
                }
            });
    }

    async onSubmit() {
        this.store.dispatch(
            CartActions.submitCart({
                businessModel: BusinessModel.PrePayment,
                paymentType: this.paymentType
            })
        );
    }
}
